import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function InProgress() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#18181b] text-white">
      <h1 className="text-4xl font-bold mb-4">Article In Progress</h1>
      <p className="text-lg text-gray-300 mb-8">This article is not yet available. Please check back soon!</p>
      <button
        onClick={() => navigate(-1)}
        className="px-4 py-2 bg-black/80 text-white text-center min-w-[6vw] rounded-full shadow border border-gray-800 hover:bg-[#121212] hover:border-gray-700 transition"
      >
        Back
      </button>
    </div>
  );
}
